import React from 'react';

const PersonInHouseCircle: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <circle cx="64" cy="64" r="57" stroke="#fff" strokeWidth="4"></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M63.247 45.03h.414a4.343 4.343 0 014.335 4.35v1.932a4.343 4.343 0 01-4.335 4.35h-.414a4.343 4.343 0 01-4.335-4.35V49.38a4.343 4.343 0 014.335-4.35v0zm.16 43.844v-16.03m-5.511-11.057v27.086m11.021-27.086v27.086"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M68.971 74.35l3.18-.967a2.511 2.511 0 001.778-2.406v-9.261a5.026 5.026 0 00-3.21-4.69 20.185 20.185 0 00-14.41-.054l-.178.067a5.025 5.025 0 00-3.244 4.703v9.404c0 1.023.62 1.945 1.567 2.33l3.39 1.375"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M85.167 91.514V58.642l6.434 4.44 3.888-6.252-12.509-9.36V37.08h-6.91v5.612l-12.265-8.895-31.412 23.036 3.909 6.232 6.412-4.44v32.89c0 .92.743 1.664 1.66 1.664h39.131c.917 0 1.66-.745 1.66-1.665h.002z"
    ></path>
  </svg>
);

export default PersonInHouseCircle;
